<dx-load-panel
  [visible]="loadingVisible"
  [showIndicator]="true"
  [showPane]="true"
  [shading]="true"
  [hideOnOutsideClick]="false"
  message="Completing sign-in with Google..."
></dx-load-panel>

<div *ngIf="errorMessage && !loadingVisible" class="error-overlay">
  <div class="error-container">
    <div class="error-icon">
      <i class="fas fa-exclamation-circle"></i>
    </div>
    <div class="error-message">{{ errorMessage }}</div>
    <div class="error-redirect">Redirecting to login page...</div>
  </div>
</div>
